import { Icon, Popconfirm } from 'antd';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { emptyFn } from 'utils/common';
import { deleteSlotById, revertSlotById } from '../flow/actions';

const defaultProps = {
  deleteSlotById: emptyFn,
  revertSlotById: emptyFn
};
const propTypes = {
  id: PropTypes.number.isRequired,
  isRevertable: PropTypes.bool.isRequired,
  deleteSlotById: PropTypes.func,
  revertSlotById: PropTypes.func
};

const PanelActions = ({ id, isRevertable, deleteSlotById, revertSlotById }) => (
  <Fragment>
    {isRevertable && (
      <Icon
        className="cursor-pointer ml-sm"
        type="reload"
        onClick={() => revertSlotById(id)}
      />
    )}
    <Popconfirm
      title={<FormattedMessage id="global.ui.dialog.deleteTitle" />}
      onConfirm={() => deleteSlotById(id)}
    >
      <Icon className="cursor-pointer ml-sm mr-xlg" type="close" />
    </Popconfirm>
  </Fragment>
);

const mapStateToProps = ({ dashboardSettings }, ownProps) => {
  const { id } = ownProps;
  const slot = dashboardSettings.details.slots.find(s => s.id === id) || {};
  return {
    isRevertable: _.isFunction(slot && slot.isRevertable)
      ? slot.isRevertable()
      : false
  };
};
const mapDispatchToProps = {
  deleteSlotById,
  revertSlotById
};
PanelActions.defaultProps = defaultProps;
PanelActions.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PanelActions);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/PanelActions.jsx